export type IBillsItem = {
    id: string;
    count: number;
    index: number;
    month: string;
    active: boolean;
    amount: number;
    issueDate: string;
    monthItem: string;
    payment: boolean;
    monthSort: string;
    legalEntity?: string;
    debt: number;
};

export type IBill = {
    id: string;
    amount: number;
    issueDate: Date;
    legalEntity: string;
    debt: number | null;
};

export type IBillContext = {
    id: string;
    amount: number;
    issueDate: Date | string;
    legalEntity: string;
    debt: number | null;
};

export type BillsMonthType = {
    active: boolean;
    amount: number;
    count: number;
    debt: number | null;
    month: string;
    monthItem: string;
    monthSort: string;
    payment: boolean;
    year: string;
};

export type BillFileType = {
    id: string;
    file: File;
};

export type IBillDetail = {
    id: string;
};

// GCO
export enum EMessageTypeGCO {
    TRACKING = 'tracking',
    FLOW = 'flow',
}

export enum EResponsePreventInteractionGCO {
    INVALID_REQUEST = 'invalid_request',
    UNAUTHORIZED_CLIENT = 'unauthorized_client',
    USER_CANCELLED = 'user_cancelled',
    SERVER_ERROR = 'server_error',
    TEMPORARILY_UNAVAILABLE = 'temporarily_unavailable',
}

export enum EResponseFinishInteractionGCO {
    SUCCESS = 'success',
    ERROR = 'error',
}

export type IEventGCO = {
    type: string;
    event: string;
};

export interface ITrackingScreenGCO {
    screen: string;
    type: string;
    id: string;
    data: { [key: string]: string };
}

export type ITrackingGCO = {
    messageType: EMessageTypeGCO;
    message: ITrackingScreenGCO;
};

export type IEventFinishInteractionGCO = {
    callbackUrl: string;
    nonce?: string;
    result: EResponseFinishInteractionGCO;
};

export type IEventPreventInteractionGCO = {
    callbackUrl: string;
    nonce?: string;
    error_description: string;
    error: EResponsePreventInteractionGCO;
};

export type IEventTrackingGCO = {
    messageType: EMessageTypeGCO;
    message: ITrackingScreenGCO;
};

export type IEventSourceGCO = {
    source: string;
    payload: IEventGCO;
};

export type IClaimList = {
    id: string;
    code: string;
    phase: string;
    creationDate: string;
};

export type IClaimDetail = {
    id: string;
    code: string;
    emisionBillDate: string;
    phase: string;
    customerComments: string;
    type: string;
    totalDisputedAmount: string;
    creationDate: string;
    endDate: string;
    claimedCustomerAccounts: [
        {
            customerAccount: string;
            totalDisputedAmountCA: string;
            claimedCustomerBills: [
                {
                    billNo: string;
                    disputedAmountCreateds: [
                        {
                            appliedCustomerBillingRates: [
                                {
                                    typeDescription?: string;
                                    product?: {
                                        identifier: string;
                                    };
                                    text?: string;
                                },
                            ];
                            appliedCustomerBillingRate: string;
                            disputedAmount: string;
                            id: string;
                            idMotive: string;
                            idSubmotive: string;
                            interactionDate: string;
                            motive: string;
                            subMotive: string;
                            totalBill: boolean;
                        },
                    ];
                    interactionDate: string;
                    totalDisputedAmountCB: string;
                },
            ];
        },
    ];
};

export type IClaimConcept = {
    id: string;
    name: string;
    motive: string;
    idMotive: string;
    idSubmotive: string;
    subMotive: string;
    amount: string;
    totalAmount: string;
    type: string;
    endDate: string;
    startDate: string;
    starDate: string;
    date?: string;
    description?: string;
    product?: {
        identifier?: string;
    };
    text?: string;
    typeId?: string;
    appliedCustomerBillingRateCharDTOOUTs: any[];
};

export type ICommunication = {
    title: string;
    message: string;
    sendDate: string;
    id: string;
    contact: string;
    statusName: string;
    shippingMethod: string;
};

export type ICommunicationDetail = {
    title: string;
    message: string;
    sendDate: string;
    id: string;
    contact: string;
    statusName: string;
    code: string;
    shippingMethod: string;
    messageHtml?: string;
};

export type IClaimContactInfo = {
    id: string;
    contactPerson: string;
    type: string;
    value: string;
    partyId: string;
    contactTypeId: string;
    interactionRoleTypeId: string;
};

export type UEventsGCO = IEventTrackingGCO & IEventSourceGCO;
export type UEventsResponseGCO = IEventFinishInteractionGCO & IEventPreventInteractionGCO;

export type ClaimsTypeTypes = 'quota' | 'additional' | '';
export type BillClaimsSelectedType = any;

export enum ContactOptions {
    sms = 'sms',
    email = 'email',
}

export type BillClaimType = {
    economicCustomerProblemCLT: {
        customerComments: string;
        interactionRoles: {
            idPartyRole?: string;
            idcontactMedium: string;
            type: string;
        }[];
        claimedCustomerAccounts: {
            customerAccount: string;
            claimedCustomerBills: {
                billNo: string;
                disputedAmountCreateds: {
                    idMotive: string;
                    idSubmotive: string;
                    disputedAmount: string;
                    appliedCustomerBillingRate?: string;
                }[];
            }[];
        }[];
    };
};
